import React, { useRef } from 'react';
import { useFramePositioning } from '../hooks/useFramePositioning.js';
import { cx } from '../utils/cx';
import { getThemeFileUri } from '../utils/wp.js';
import { RootPortal } from './RootPortal';

export function FullScreenLoader({message, visible}) {
    const loader = useRef(null);

    const {center} = useFramePositioning(loader, visible);

    return (
        <RootPortal>
            <div
                className={cx(
                    'fixed top-0 w-screen h-screen z-[9999] bg-white bg-opacity-75',
                    visible ? 'visible' : 'hidden',
                )}
            >
                {visible &&
                    <div
                        className="fixed left-1/2 -translate-x-1/2 top-1/2 w-full max-w-[90vw]"
                        ref={loader}
                        style={{
                            top: center,
                        }}
                    >
                        <div className="w-[64px] h-[64px] p-2 mx-auto bg-white rounded-full border border-primary">
                            <video
                                className="rounded-full"
                                controls={false}
                                autoPlay={true}
                                muted={true}
                                loop={true}
                                playsInline
                            >
                                <source
                                    src={getThemeFileUri(
                                        'static/images/loader.webm')}
                                    type="video/webm"
                                />
                            </video>
                        </div>
                        <div className="mt-4 font-bold text-2xl text-black text-center animate-bounce">
                            {message}
                        </div>
                    </div>
                }
            </div>
        </RootPortal>
    );
}
